import { createAsyncThunk } from '@reduxjs/toolkit';
import { rejectServerError } from './thunkUtils';
import { getSystemTypeMap } from 'services/devices/devices.service';

// Fetch the system type map used for integration grouping.
export const fetchSystemTypeMap = createAsyncThunk(
  'integration/fetchSystemTypeMap',
  async (_, { rejectWithValue }) => {
    const res = await getSystemTypeMap();
    if (res?.status !== 200) return rejectServerError(rejectWithValue);
    return res?.data?.result;
  },
);
